export const GET_OPERATORS_SUCCESS = 'GET_OPERATORS_SUCCESS';
